export default "__VITE_ASSET__DDX7Hryj__"